export const SITEMAP_PRIORITIES = {
  /** 블로그 랜딩(/blog) — 블로그의 정식 진입점이라 아카이브보다 높다 */
  LANDING: 0.9,
  ALL_CATEGORY: 0.8,
  CATEGORY: 0.7,
  BLOG_POST: 0.6,
  FAQ_POST: 0.6,
} as const;
